export default __webpack_public_path__ + "static/media/topbar-img.1c0ad86e.png";